import Typography from "@vapor/react-extended/ExtendedTypography";
import Grid from "@vapor/react-material/Grid";
import Box from "@vapor/react-material/Box";
import { StatSection } from "./StatComponents";

const PrestazioniStatsTab = ({ isLoading, displayStats, riskColors }) => {
    return (
        <>
            {isLoading && 
                <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                    <Typography>Caricamento dati statistici...</Typography>
                </Box>
            }
            {!isLoading && 
            <>
                <Typography variant="h5" sx={{ mb: 3, textAlign: 'center', color: '#000000ff', fontSize: '1.25rem' }}>
                    Punteggi delle Prestazioni
                </Typography>
                
                {/* Prima sezione: B1-B4 */}
                <Grid container spacing={2} sx={{ mb: 4 }}>
                    <Grid item xs={12} md={6}>
                        <StatSection
                            title="Prestazioni con"
                            stats={displayStats?.valutazioni}
                            colors={['#91d250', '#ff5c5f']}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <StatSection
                            title="Zone Geografiche"
                            stats={displayStats?.prestazioniAreaGeografica}
                            colors={riskColors}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <StatSection
                            title="B1 - Tipologia Prestazione"
                            stats={displayStats?.b1Punteggio}
                            colors={riskColors}
                        />
                    </Grid>
                    
                    <Grid item xs={12} md={6}>
                        <StatSection
                            title="B2 - Modalità di svolgimento"
                            stats={displayStats?.b2Punteggio}
                            colors={riskColors}
                        />
                    </Grid>
                    
                    <Grid item xs={12} md={6}>
                        <StatSection
                            title="B3 - Ammontare dell'operazione"
                            stats={displayStats?.b3Punteggio}
                            colors={riskColors}
                        />
                    </Grid>
                    
                    <Grid item xs={12} md={6}>
                        <StatSection
                            title="B4 - Frequenza Operazioni"
                            stats={displayStats?.b4Punteggio}
                            colors={riskColors}
                        />
                    </Grid>                                                   
                                
                    <Grid item xs={12} md={6}>
                        <StatSection
                            title="B5 - Ragionevolezza"
                            stats={displayStats?.b5Punteggio}
                            colors={riskColors}
                        />
                    </Grid>
                    
                    <Grid item xs={12} md={6}>
                        <StatSection
                            title="B6 - Area geografica di destinazione"
                            stats={displayStats?.b6Punteggio}
                            colors={riskColors}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <StatSection
                            title="Rischio inerente"
                            stats={displayStats?.rischioInerente}
                            colors={riskColors}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <StatSection
                            title="Rischio specifico prestazioni"
                            stats={displayStats?.rischioSpecificoPrestazione}
                            colors={riskColors}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <StatSection
                            title="Rischio specifico complessivo"
                            stats={displayStats?.rischioSpecificoComplessivo}
                            colors={riskColors}
                        />
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <StatSection
                            title="Rischio effettivo"
                            stats={displayStats?.rischioEffettivo}
                            colors={riskColors}
                        />
                    </Grid>
                </Grid>
            </>}
        </>
    );
};

export default PrestazioniStatsTab;